import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { CounterComponent } from './counter/counter.component';
import { FetchDataComponent } from './fetch-data/fetch-data.component';
import { LandingComponent } from './landing/landing.component';
import { ValidateComponent } from './validate/validate.component';
import { ShoppingCartModule } from 'ng-shopping-cart';
import { OrderItem } from './models/order-item';
import { CartViewzComponent } from './cart-view/cart-view-component';
import { ShoppingCartComponent } from './shopping-cart/shopping-cart';
import { TenantService } from './services/data.tenant';
import * as toaster from "toastr";
import { InvoiceService } from './services/data.invoice';
import { ProductService } from './services/data.product';
import { InvoiceComponent } from './invoice/invoice.component';
import { PhonePipe } from './pipes/PhonePipe';
import { PrintComponent } from './print-component/print.component';
@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    CounterComponent,
    LandingComponent,
    ValidateComponent,
    FetchDataComponent,
    CartViewzComponent,
    InvoiceComponent,
    ShoppingCartComponent,
    PhonePipe,
    PrintComponent
  ],
  imports: [
    ShoppingCartModule.forRoot({
      itemType: OrderItem,
      serviceType: 'localStorage',
      serviceOptions: {
        storageKey: 'NgShoppingCart',
        clearOnError : true
      }
    }),
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: LandingComponent, pathMatch: 'full' },
      { path: 'frenzy/:id', component: LandingComponent, pathMatch: 'full' },
      { path: 'validate/:code', component: ValidateComponent, pathMatch: 'full' },
      { path: 'validate', component: ValidateComponent, pathMatch: 'full' },
      { path: 'counter', component: CounterComponent },
      { path: 'fetch-data', component: FetchDataComponent },
      { path: 'shopping-cart', component: ShoppingCartComponent }
    ])
  ],
  providers: [TenantService, InvoiceService, ProductService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts